module.exports = __webpack_public_path__ + "img/ticket_active.11aaf95d.svg";